import { Box, CircularProgress } from '@mui/material';

import {
  BillableHoursProposalProps,
  BonusProposalProps,
  ProposalProps,
  ProposalType,
  SalaryProposalProps,
} from '~/data/proposals';
import { WorkflowsEmployeeProposalsDialog_OnUpdateLegacy } from '~/library/WorkflowsEmployeeProposalsDialog/component';
import { EmployeeBillableHoursProposalsLayout } from '~/scenes/RewardingModule/components/EmployeeProposalsDialog/components/EmployeeProposals/components/EmployeeBillableHoursProposalsLayout';
import { EmployeeBonusProposalsLayout } from '~/scenes/RewardingModule/components/EmployeeProposalsDialog/components/EmployeeProposals/components/EmployeeBonusProposalsLayout';
import { EmployeeProposalsLayout } from '~/scenes/RewardingModule/components/EmployeeProposalsDialog/components/EmployeeProposals/components/EmployeeProposalsLayout';
import { EmployeeProposalsLayoutProps } from '~/scenes/RewardingModule/components/EmployeeProposalsDialog/components/EmployeeProposals/components/EmployeeProposalsLayout/component';
import { EmployeeSalaryProposalsLayout } from '~/scenes/RewardingModule/components/EmployeeProposalsDialog/components/EmployeeProposals/components/EmployeeSalaryProposalsLayout';
import { useEmployeeProposals } from '~/scenes/RewardingModule/components/EmployeeProposalsDialog/components/EmployeeProposals/useEmployeeProposals';

type PropsType = WorkflowsEmployeeProposalsDialog_OnUpdateLegacy & {
  proposalType: ProposalType;
};

export const EmployeeProposals = (props: PropsType) => {
  const { proposalType, onUpdateLegacy } = props;

  const {
    user,
    isLoading,
    proposalsList: { proposals },
    newProposal,
    handleProposalUpdate,
  } = useEmployeeProposals({ proposalType, onUpdateLegacy });

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <CircularProgress />
      </Box>
    );
  }

  const proposalsLayoutProps = {
    proposals,
    newProposal,
    onProposalUpdate: handleProposalUpdate,
    user,
  };

  switch (proposalType) {
    case ProposalType.SALARY_PROPOSAL:
      return (
        <EmployeeSalaryProposalsLayout
          {...(proposalsLayoutProps as EmployeeProposalsLayoutProps<SalaryProposalProps>)}
        />
      );
    case ProposalType.BONUS_PROPOSAL:
      return (
        <EmployeeBonusProposalsLayout
          {...(proposalsLayoutProps as EmployeeProposalsLayoutProps<BonusProposalProps>)}
        />
      );
    case ProposalType.BILLABLE_HOURS:
      return (
        <EmployeeBillableHoursProposalsLayout
          {...(proposalsLayoutProps as EmployeeProposalsLayoutProps<BillableHoursProposalProps>)}
        />
      );
    default:
      return (
        <EmployeeProposalsLayout
          {...(proposalsLayoutProps as EmployeeProposalsLayoutProps<ProposalProps>)}
        />
      );
  }
};
